module.exports = __webpack_public_path__ + "static/img/7_2.bd383fcc.jpg";